import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

// Pre-flight Stripe health gate + outage-waitlist capture. Probes only while `active`.
export default function usePaymentsGate(active) {
  const [paymentsHealthy, setPaymentsHealthy] = useState(null); // null = not checked
  const [paymentsReason, setPaymentsReason] = useState("");
  const [waitlistEmail, setWaitlistEmail] = useState("");
  const [waitlistBusy, setWaitlistBusy] = useState(false);
  const [waitlistDone, setWaitlistDone] = useState(false);

  useEffect(() => {
    if (!active) return;
    let alive = true;
    (async () => {
      try {
        const { data } = await api.get("/payments/health");
        if (!alive) return;
        setPaymentsHealthy(!!data.healthy);
        setPaymentsReason(data.reason || "");
      } catch {
        if (!alive) return;
        setPaymentsHealthy(false);
        setPaymentsReason("network_error");
      }
    })();
    return () => { alive = false; };
  }, [active]);

  const joinWaitlist = async () => {
    const email = waitlistEmail.trim().toLowerCase();
    if (!email || !email.includes("@") || email.length < 5) {
      toast.error("Enter a valid email");
      return;
    }
    setWaitlistBusy(true);
    try {
      await api.post("/payments/waitlist", { email, source: "payments_offline_create" });
      setWaitlistDone(true);
      toast.success("You're on the list — we'll email you the moment payments are back");
    } catch {
      toast.error("Couldn't save your email — try again");
    } finally {
      setWaitlistBusy(false);
    }
  };

  const markPaymentsDown = (reason) => {
    setPaymentsHealthy(false);
    setPaymentsReason(reason);
  };

  return {
    paymentsHealthy,
    paymentsReason,
    markPaymentsDown,
    waitlistEmail,
    setWaitlistEmail,
    waitlistBusy,
    waitlistDone,
    joinWaitlist,
  };
}
